import dynamic from "next/dynamic"
const BoxContainer = dynamic(() => import("../Reusables/BoxContainer"));
const TypographyGridCol = dynamic(() => import("../Reusables/TypographyGridCol"));
const PurchaseForm = dynamic(() => import("./PurchaseForm"));



const Purchase = (props) => {
    const {
        template_page_content,
        template_page_settings
    } = props;

    return (
        <BoxContainer template_page_settings={template_page_settings}>
            <TypographyGridCol
                title={template_page_content?.heading?.title}
                subtitle={template_page_content?.heading?.content}
                gridProps={{ xs: 12, lg: 12 }}
            >
                <PurchaseForm {...props} />
            </TypographyGridCol>
        </BoxContainer>
    )
}

export default Purchase